import { baseApi } from "../baseApi";
import type { UploadFilesResponse } from "./type";

export const uploadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadPrivateFiles: builder.mutation<UploadFilesResponse, File[]>({
      query: (files) => {
        const body = new FormData();
        body.append("purpose", "chat");
        files.forEach((file) => body.append("files", file));
        return { url: "/uploads/files", method: "POST", body };
      },
    }),
  }),
});

export const { useUploadPrivateFilesMutation } = uploadApi;
